<template>
  <div class="chinese_detail">
    <breadcrumb :titleList="titleList"></breadcrumb>
    <div class="chinese_detail-wrap">
      <div class="chinese_detail-contain">
        <page-title :title="clients.cunitsname">
        </page-title>
        <detail-card :title="'基本信息'">
          <div class="chinese_detail-row_wrap">
            <el-row>
              <el-col :span="5">所在省：{{clients.providName}}</el-col>
              <el-col :span="5">所在市：{{clients.cityidName}}</el-col>
              <el-col :span="5">所在区：{{clients.countyName}}</el-col>
              <el-col :span="9">地址：{{clients.caddress}}</el-col>
            </el-row>
            <el-row>
              <el-col :span="5">类别：{{clients.typeName}}</el-col>
              <el-col :span="5">级别：{{clients.levelName}}</el-col>
              <el-col :span="5">广告客户：{{clients.cadvip?'是':'否'}}</el-col>
              <el-col :span="9">主要覆盖区域：{{clients.areaName}}</el-col>
            </el-row>
            <el-row>
              <el-col :span="15">整合情况：{{clients.intergrationName}}</el-col>
              <el-col :span="9">全网用户数：{{clients.camount}}</el-col>
            </el-row>
            <el-row>
              <div>备注：{{clients.cmemo}}</div>
            </el-row>
            <el-row>
              <el-col :span="15">创建者/日期：{{clients.createUserName}}/{{clients.createTime?clients.createTime.split('T')[0]:""}}</el-col>
              <el-col :span="9">最近修改：{{clients.updateUserName}}/{{clients.updateTime?clients.updateTime.split('T')[0]:""}}</el-col>
            </el-row>
          </div>
          <div>
            <el-button @click="editClientForm">
              <font-awesome-icon style="color:#9b9b9b; margin-right:6px;"
                                 :icon="['fas', 'pencil-alt']" />编辑
            </el-button>
          </div>
        </detail-card>
        <detail-card :title="'数字电视'">
          <div v-if="clientDigital"
               class="chinese_detail-row_wrap">
            <el-row>
              <el-col :span="9">数字用户数：{{clientDigital.digitalTvUserNumber}}</el-col>
              <el-col :span="9">双向覆盖户数：{{clientDigital.idDupcover}}</el-col>
              <el-col :span="6">双向机顶盒数：{{clientDigital.ddupsum}}</el-col>
            </el-row>
            <el-row>
              <el-col :span="9">凤凰VOD业务情况：{{clientDigital.vodName}}</el-col>
              <el-col :span="15">是否签约凤凰专区：{{clientDigital.issignPhtv?'是':'否'}}</el-col>
            </el-row>
            <el-row>节目包与凤凰频道说明：{{clientDigital.dsummary}}</el-row>
            <el-row>数字整转备注：{{clientDigital.dmemo}}</el-row>
            <el-row>
              <el-col :span="15">创建者/日期：{{clientDigital.createName}}/{{clientDigital.createTime.split('T')[0]}}</el-col>
              <el-col :span="9">最近修改：{{clientDigital.updateName}}/{{clientDigital.updateTime.split('T')[0]}}</el-col>
            </el-row>
          </div>
          <div>
            <el-button @click="editClientDigital">
              <font-awesome-icon style="color:#9b9b9b; margin-right:6px;"
                                 :icon="['fas', 'pencil-alt']" />编辑
            </el-button>
            <el-button @click="delDigital(clientDigital.did)"
                       type="danger"
                       plain>删除</el-button>
          </div>
        </detail-card>
        <detail-card :title="'中文台'">
          <span v-if="clientView.length"
                slot="left"
                :style="{color:clientView[0].isaudit===1?'#D44052':'#39B54A'}">【{{clientView[0].isaudit===1?'户数审核中':'户数已审核'}}】</span>
          <div v-if="clientView.length"
               class="chinese_detail-row_wrap">
            <el-row>
              <el-col :span="9">用户数：{{clientView[0].vsum}}</el-col>
               <el-col :span="6">是否包含上级网络：{{clientView[0].cinclude?'包含':'不包含'}}</el-col>
            </el-row>
            <el-row>
              <el-col :span="9">信号源：{{clientView[0].sourceName}}</el-col>
              <el-col :span="9">传送方式：{{clientView[0].signalName}}</el-col>
              <el-col :span="6">收看政策：{{clientView[0].viewingPolicyName}}</el-col>
            </el-row>
            <el-row>收视政策说明：{{clientView[0].vmemo}}</el-row>
            <el-row>数据来源和可靠性说明：{{clientView[0].vsummary}}</el-row>
            <el-row>数据开始日期：{{clientView[0].createName}}/{{clientView[0]?clientView[0].createTime.split('T')[0]:""}}</el-row>
          </div>
          <div class="chinese_detail-history">
            <div @click="chHistory=!chHistory"
                 class="chinese_detail-history_title">修改历史
              <font-awesome-icon v-if="!chHistory"
                                 style=" margin-left:10px;"
                                 :icon="['fas', 'angle-down']" />
              <font-awesome-icon v-else
                                 style=" margin-left:10px;"
                                 :icon="['fas', 'angle-up']" />
            </div>
            <table v-show="chHistory">
              <tr>
                <th>说明</th>
                <th>变动日期</th>
                <th>原户数</th>
                <th>修改类型</th>
                <th>影响户数</th>
                <th>改后户数</th>
              </tr>
              <tr v-for="item in clientView"
                  :key="item.mid">
                <td>{{item.vsummary}}</td>
                <td>{{item.createTime.split('T')[0]}}</td>
                <td>{{item. originalNum}}</td>
                <td>{{item.modafyType}}</td>
                <td>{{item.effectNum}}</td>
                <td>{{item.vsum}}</td>
              </tr>
            </table>
          </div>
          <div>
            <el-button @click="editClientViewForm(0)">
              <font-awesome-icon style="color:#9b9b9b; margin-right:6px;"
                                 :icon="['fas', 'pencil-alt']" />编辑
            </el-button>
            <el-button @click="openClientView(0)"
                       type="success"
                       v-if="clientView[0]&&clientView[0].isopen===1"
                       plain>开启</el-button>
            <el-button @click="closeClientView(0)"
                       type="danger"
                       v-else
                       plain>关闭</el-button>
          </div>
        </detail-card>
        <detail-card :title="'资讯台'">
          <span v-if="information.length"
                slot="left"
                :style="{color:information[0].isaudit===1?'#D44052':'#39B54A'}">【{{information[0].isaudit===1?'户数审核中':'户数已审核'}}】</span>
          <div v-if="information.length"
               class="chinese_detail-row_wrap">
            <el-row>
              <el-col :span="9">用户数：{{information[0].vsum}}</el-col>
                 <el-col :span="6">是否包含上级网络：{{information[0].cinclude?'包含':'不包含'}}</el-col>
            </el-row>
            <el-row>
              <el-col :span="9">信号源：{{information[0].sourceName}}</el-col>
              <el-col :span="9">传送方式：{{information[0].signalName}}</el-col>
              <el-col :span="6">收看政策：{{information[0].viewingPolicyName}}</el-col>
            </el-row>
            <el-row>收视政策说明：{{information[0].vmemo}}</el-row>
            <el-row>数据来源和可靠性说明：{{information[0].vsummary}}</el-row>
            <el-row>数据开始日期：{{information[0].createName}}/{{information[0].createTime.split('T')[0]}}</el-row>
          </div>
          <div class="chinese_detail-history">
            <div @click="inHistory=!inHistory"
                 class="chinese_detail-history_title">修改历史
              <font-awesome-icon v-if="!inHistory"
                                 style=" margin-left:10px;"
                                 :icon="['fas', 'angle-down']" />
              <font-awesome-icon v-else
                                 style=" margin-left:10px;"
                                 :icon="['fas', 'angle-up']" />
            </div>
            <table v-show="inHistory">
              <tr>
                <th>说明</th>
                <th>变动日期</th>
                <th>原户数</th>
                <th>修改类型</th>
                <th>影响户数</th>
                <th>改后户数</th>
              </tr>
              <tr v-for="item in information"
                  :key="item.mid">
                <td>{{item.vsummary}}</td>
                <td>{{item.createTime.split('T')[0]}}</td>
                <td>{{item. originalNum}}</td>
                <td>{{item.modafyType}}</td>
                <td>{{item.effectNum}}</td>
                <td>{{item.vsum}}</td>
              </tr>
            </table>
          </div>
          <div>
            <el-button @click="editClientViewForm(1)">
              <font-awesome-icon style="color:#9b9b9b; margin-right:6px;"
                                 :icon="['fas', 'pencil-alt']" />编辑
            </el-button>
            <el-button @click=" openClientView(1)"
                       type="success"
                       v-if="information[0]&&information[0].isopen===1"
                       plain>开启</el-button>
            <el-button @click="closeClientView(1)"
                       type="danger"
                       v-else
                       plain>关闭</el-button>
          </div>
        </detail-card>
        <detail-card :title="'联系人'">
          <div @click="editContact(-1)"
               class="chinese_detail-add"
               slot="right">
            <font-awesome-icon style="color:#39B54A; margin-right:10px;"
                               :icon="['fas', 'plus-circle']" />添加联系人
          </div>
          <table class="chinese_detail-contact">
            <tr>
              <th>姓名</th>
              <th>职位</th>
              <th>手机</th>
              <th>座机</th>
              <th>地址</th>
              <th>操作</th>
            </tr>
            <tr v-for="(item,index) in contact"
                :key="item.cid">
              <td>{{item.cname}}</td>
              <td>{{item.cposition}}</td>
              <td>{{item.cphoen}}</td>
              <td>{{item.ctel}}</td>
              <td>{{item.caddress}}</td>
              <td style="cursor:pointer; color:#F0722B"
                  @click="editContact(index)">编辑</td>
            </tr>
          </table>
        </detail-card>
      </div>
    </div>
    <!--编辑基本信息-->
    <el-dialog with="740px" :close-on-click-modal="false" class="chinese_detail-dialog"
               title="基本信息"
               :visible.sync="clientFormShow">
      <el-form label-position="top"
               class="chinese_detail-form">
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="单位">
              <el-input v-model="clientForm.cunitsname"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="类别">
              <el-select @change="typeChange"
                         v-model="clientForm.ctype">
                <el-option v-for="item in typeList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="级别">
              <el-select v-model="clientForm.clevel">
                <el-option v-for="item in levelList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <div class="chinese_detail-checkbox">
              <el-checkbox v-model="clientForm.cadvip">广告客户</el-checkbox>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="4">
            <el-form-item label="省">
              <el-select @change="providChange"
                         v-model="clientForm.cprovid">
                <el-option v-for="item in providList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="市">
              <el-select @change="cityChange"
                         v-model="clientForm.ccityid">
                <el-option v-for="item in cityList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="区">
              <el-select v-model="clientForm.ccounty">
                <el-option v-for="item in countyList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地址">
              <el-input v-model="clientForm.caddress"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="用户主要覆盖区域">
              <el-select v-model="clientForm.carea">
                <el-option v-for="item in areaTypeList"
                           :key="item.code"
                           :label="item.desc"
                           :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="整合情况信号来源">
              <el-select v-model="clientForm.cintergration">
                <el-option v-for="item in intergrationList"
                           :key="item.code"
                           :label="item.desc"
                           :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="全网户数">
              <el-input v-model="clientForm.camount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <div class="chinese_detail-checkbox">
              <el-checkbox v-model="clientForm.isSevendaysMove">是否支持7天时移</el-checkbox>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="备注">
              <el-input type="textarea"
                      :rows="5"
                      v-model="clientForm.cmemo"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitEditClient()"  :loading="dialogLoading">提 交</el-button>
        <el-button @click="clientFormShow = false">取 消</el-button>
      </div>
    </el-dialog>
    <!--数字电视信息-->
    <el-dialog with="740px" :close-on-click-modal="false" class="chinese_detail-dialog"
               title="数字电视信息"
               :visible.sync="clientDigitalShow">
      <el-form label-position="top"
               class="chinese_detail-form">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="数字电视用户数">
              <el-input v-model="clientDigitalForm.digitalTvUserNumber"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="双向网络可覆盖用户数">
              <el-input v-model="clientDigitalForm.idDupcover"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="实际双向机顶盒数">
              <el-input v-model="clientDigitalForm.ddupsum"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="凤凰VOD业务状况">
              <el-select v-model="clientDigitalForm.dvod">
                <el-option v-for="item in vodList"
                           :key="item.code"
                           :label="item.desc"
                           :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <div class="chinese_detail-checkbox">
              <el-checkbox v-model="clientDigitalForm.issignPhtv">已签约凤凰专区</el-checkbox>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="节目包与凤凰频道说明">
                 <el-input type="textarea"
                      :rows="5"
                      v-model="clientDigitalForm.dsummary"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="数字整转进度说明">
                 <el-input type="textarea"
                      :rows="5"
                      v-model="clientDigitalForm.dmemo"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitClientDigitalView()" :loading="dialogLoading">提 交</el-button>
        <el-button @click="clientDigitalShow = false">取 消</el-button>
      </div>
    </el-dialog>
    <!--中文台/资讯台信息-->
    <el-dialog with="740px" :close-on-click-modal="false" class="chinese_detail-dialog"
               :title="(clientViewForm.vchannel?'资讯台':'中文台')+'收视信息'"
               :visible.sync="clientViewFormShow">
      <el-form label-position="top"
               class="chinese_detail-form">
        <el-row :gutter="15">
          <el-col :span="8">
            <el-form-item :label="(clientViewForm.vchannel?'资讯台':'中文台')+'用户数'">
              <el-input v-model="clientViewForm.vsum"></el-input>
            </el-form-item>
          </el-col>
               <el-col :span="8">
            <div class="chinese_detail-checkbox">
              <el-checkbox v-model="clientViewForm.vlicence">有收视许可</el-checkbox>
            </div>
          </el-col>
             <el-col :span="8">
            <div class="chinese_detail-checkbox">
              <el-checkbox v-model="clientViewForm.cinclude">此户数已经包含在上级网络中</el-checkbox>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item :label="(clientViewForm.vchannel?'资讯台':'中文台')+'信号来源'">
            <el-checkbox-group v-model="clientViewForm.vsourceIdList">
              <el-checkbox v-for="item in sourceEnumList"
                           :label="item.code"
                           :key="item.code">{{item.desc}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item :label="(clientViewForm.vchannel?'资讯台':'中文台')+'传送方式'">
            <el-radio-group v-model="clientViewForm.vsignal">
              <el-radio v-for="item in singalEnumList"
                        :label="item.code"
                        :key="item.code">{{item.desc}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item :label="(clientViewForm.vchannel?'资讯台':'中文台')+'收视政策'">
            <el-checkbox-group v-model="clientViewForm.viewingPolicyIdList">
              <el-checkbox v-for="item in policyEnumList"
                           :label="item.code"
                           :key="item.code">{{item.desc}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="收视政策备注">
                <el-input type="textarea"
                      :rows="5"
                      v-model="clientViewForm.vmemo"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="数据来源可靠性说明">
                      <el-input type="textarea"
                      :rows="5"
                      v-model="clientViewForm.vsummary"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitEditClientView()" :loading="dialogLoading">提 交</el-button>
        <el-button @click="clientViewFormShow = false">取 消</el-button>
      </div>
    </el-dialog>
    <!--联系人信息-->
    <el-dialog with="740px" :close-on-click-modal="false" class="chinese_detail-dialog"
               title="联系人信息"
               :visible.sync="contactFormShow">
      <el-form label-position="top"
               class="chinese_detail-form">
        <el-row :gutter="22">
          <el-col :span="8">
            <el-form-item label="姓名">
              <el-input v-model="contactForm.cname"
                        placeholder="请输入姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="性别">
              <el-select v-model="contactForm.csex"
                         placeholder="请选择">
                <el-option label="男"
                           :value="0"></el-option>
                <el-option label="女"
                           :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="年龄">
              <el-input v-model="contactForm.cage"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="职务">
              <el-input v-model="contactForm.cposition"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="8">
            <el-form-item label="手机">
              <el-input v-model="contactForm.cphoen"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="固话">
              <el-input v-model="contactForm.ctel"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="传真">
              <el-input v-model="contactForm.cfax"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="8">
            <el-form-item label="区号">
              <el-input v-model="contactForm.czonecode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="邮编">
              <el-input v-model="contactForm.czipcode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="微信">
              <el-input v-model="contactForm.cqm"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="地址">
            <el-input v-model="contactForm.caddress"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="简历">
            <el-input type="textarea"
                      :rows="5"
                      v-model="contactForm.cresume"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitContact()" :loading="dialogLoading">提 交</el-button>
        <el-button @click="contactFormShow = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import axios from '@/servies/axios'
import api from '@/servies/api'
import pageTitle from '@/components/pageTitle'
import breadcrumb from '@/components/breadcrumb'
import detailCard from '@/components/detailCard'
export default {
  components: {
    pageTitle,
    breadcrumb,
    detailCard
  },
  data() {
    return {
      titleList:[],
      from:'',
      dialogLoading: false,
      id: '',
      clients: '',
      clientDigital: '',
      clientView: '',
      information: '',
      contact: '',
      inHistory: false,
      chHistory: false,
      clientForm: {
        caddress: '',
        cadvip: false,
        camount: '',
        carea: '',
        ccityid: '',
        ccounty: '',
        isSevendaysMove: false,
        cintergration: '',
        clevel: '',
        cmemo: '',
        cprovid: '',
        ctype: '',
        cunitsname: ''
      },
      clientFormShow: false,
      clientDigitalForm: {
        digitalTvUserNumber: '',
        dinclude: '',
        idDupcover: '',
        ddupsum: '',
        dvod: '',
        dsummary: '',
        dmemo: '',
        issignPhtv: false,
        did: ''
      },
      clientDigitalShow: false,
      clientViewForm: {
        cinclude:false,
        vsum: '',
        vosum: '',
        vlicence: false,
        vsourceIdList: [],
        viewingPolicyIdList: [],
        vsignal: '',
        viewingPolicy: '',
        vmemo: '',
        vsummary: '',
        vchannel: '',
        vid: ''
      },
      clientViewFormShow: false,
      contactForm: {
        cname: '',
        csex: '',
        cposition: '',
        cage: '',
        cphoen: '',
        ctel: '',
        czonecode: '',
        czipcode: '',
        cqm: '',
        caddress: '',
        cfax: '',
        cresume: '',
        ctype: 1
      },
      contactAdd:false,
      contactFormShow: false,
      typeList: [],
      intergrationList: [],
      areaTypeList: [],
      levelList: [],
      providList: [],
      cityList: [],
      countyList: [],
      vodList: [],
      policyEnumList: [],
      singalEnumList: [],
      sourceEnumList: []
    }
  },
  created() {
    this.id = this.$route.params.id
    this.getDetail()
        this.getSelectList()

  },
  beforeRouteEnter(to,from,next){
    next(vm=>{
      vm.from = from.fullPath
    })
  },
  methods: {
    getSelectList() {
      Promise.all([
        //获取类别--级别
        axios.get(api.clientCategory).then(res => {
          if (res.data.code === 0) {
            console.log('获取类型--级别列表成功', res.data.result)
            this.typeList = res.data.result
          } else {
            console.log('获取类型--级别列表失败', res.data.msg)
          }
        }),
        //获取信号来源列表
        axios.get(api.getIntergrationTypeEnumList).then(res => {
          if (res.data.code === 0) {
            console.log('获取信号来源列表成功', res.data.result)
            this.intergrationList = res.data.result
          } else {
            console.log('获取信号来源列表失败', res.data.msg)
          }
        }),
        //获取覆盖区域列表
        axios.get(api.getAreaTypeEnumList).then(res => {
          if (res.data.code === 0) {
            console.log('获取覆盖区域列表成功', res.data.result)
            this.areaTypeList = res.data.result
          } else {
            console.log('获取覆盖区域列表失败', res.data.msg)
          }
        }),
        //获取省-市-区列表
        axios.post(api.areaListAuth).then(res => {
          if (res.data.code === 0) {
            console.log('获取省-市-区列表成功', res.data.result)
            this.providList = res.data.result
          } else {
            console.log('获取省-市-区列表失败', res.data.msg)
          }
        }),
        //获取vod业务状况列表
        axios.get(api.clientGetVodTypeEnumList).then(res => {
          if (res.data.code === 0) {
            console.log('获取vod业务状况列表成功', res.data.result)
            this.vodList = res.data.result
          } else {
            console.log('获取vod业务状况列表失败', res.data.msg)
          }
        }),
        //中文台选择框选择列表
        axios.get(api.getClientSourceEnumList).then(res => {
          if (res.data.code === 0) {
            console.log('中文台选择框选择列表成功', res.data.result)
            this.policyEnumList = res.data.result.policyEnumList
            this.singalEnumList = res.data.result.singalEnumList
            this.sourceEnumList = res.data.result.sourceEnumList
          } else {
            console.log('中文台选择框选择列表失败', res.data.msg)
          }
        })
      ])
        .then(() => {})
        .catch(error => {
          console.log(error)
          this.$message.error('网络错误，稍后重试')
        })
    },
    setTitleList(){
        if(this.$route.query.from==='static'){
        this.titleList =  [{name:'凤凰管理系统', src:'/home'},{name:'数据统计'},{name:'户数报表',src:this.from},{name:this.clients.cunitsname}]
      }
      else {
        this.titleList =  [{name:'凤凰管理系统', src:'/home'},{name:`${this.$route.query.from==='bussiness'?'中文台资讯台业务':'中文台资讯台审核'}`,src:this.from},{name:this.clients.cunitsname}]
      }
    },
    getDetail() {
      // 获取详情
      axios
        .get(api.clientDetails + `?id=${this.id}`)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取中文台客户详情成功', res.data.result)
            this.clients = res.data.result.clients[0]
            this.clientDigital = res.data.result.clientDigital.length
              ? res.data.result.clientDigital[0]
              : ''
            this.clientView = res.data.result.clientView || []
            this.information = res.data.result.information || []
            this.contact = res.data.result.contact
            this.setTitleList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，请稍后重试')
        })
    },
    //类别改变
    typeChange() {
      let index
      for (let i in this.typeList) {
        if (this.typeList[i].id === this.clientForm.ctype) {
          index = i
          break
        }
      }
      this.levelList = this.typeList[index].children
    },
    //省改变
    providChange() {
      let index
      for (let i in this.providList) {
        if (this.providList[i].id === this.clientForm.cprovid) {
          index = i
          break
        }
      }
      this.cityList = this.providList[index].children
    },
    //市改变
    cityChange() {
      let index
      for (let i in this.cityList) {
        if (this.cityList[i].id === this.clientForm.ccityid) {
          index = i
          break
        }
      }
      console.log(this.cityList[index])
      this.countyList = this.cityList[index].children
    },
    //编辑基本信息
    editClientForm() {
      this.clientForm = _.pick(this.clients, _.keys(this.clientForm))
      this.clientForm.cadvip = !!this.clientForm.cadvip
      this.clientForm.isSevendaysMove = !!this.clientForm.isSevendaysMove
      this.providChange()
      this.cityChange()
      this.typeChange()
      this.clientFormShow = true
    },
    //提交修改基本信息
    submitEditClient() {
      this.dialogLoading = true
      let params = _.cloneDeep(this.clientForm)
      params.isSevendaysMove = Number(this.clientForm.isSevendaysMove)
      params.cadvip = Number(this.clientForm.cadvip)
      params.cid = this.id
      axios
        .post(api.updateClientClients, params)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: '修改基本信息成功',
              type: 'success'
            })
            this.clientFormShow = false
             this.dialogLoading = false;
            this.getDetail()
          } else {
             this.dialogLoading = false;
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
           this.dialogLoading = false;
          this.$message.error('网络错误，稍后重试')
        })
    },
    //编辑中文台/资讯台信息
    editClientViewForm(channel) {
      if (channel === 0) {
        if (this.clientView.length) {
          this.clientViewForm = _.pick(
            this.clientView[0],
            _.keys(this.clientViewForm)
          )
          this.clientViewForm.vlicence = !!this.clientViewForm.vlicence
          this.clientViewForm.cinclude = !!this.clientViewForm.cinclude
        } else {
          this.clientViewForm = {
            vsum: '',
            vosum: '',
            vlicence: false,
            vsourceIdList: [],
            viewingPolicyIdList: [],
            vsignal: '',
            viewingPolicy: '',
            vmemo: '',
            vsummary: '',
            vchannel: 0,
            cinclude:false,
          }
        }
      } else {
        if (this.information.length) {
          this.clientViewForm = _.pick(
            this.information[0],
            _.keys(this.clientViewForm)
          )
          this.clientViewForm.vlicence = !!this.clientViewForm.vlicence
          this.clientViewForm.cinclude = !!this.clientViewForm.cinclude
          console.log(this.clientViewForm)
        } else {
          this.clientViewForm = {
            vsum: '',
            vosum: '',
            vlicence: false,
            vsourceIdList: [],
            viewingPolicyIdList: [],
            vsignal: '',
            viewingPolicy: '',
            vmemo: '',
            vsummary: '',
            vchannel: 1,
            cinclude:false,
          }
        }
      }
      this.clientViewForm.vclientid = this.id
      this.clientViewFormShow = true
    },
    //提交中文台/资讯台信息
    submitEditClientView() {
      this.dialogLoading = true;
      let params = _.cloneDeep(this.clientViewForm)
      params.vlicence = Number(params.vlicence)
      params.cinclude = Number(params.cinclude)
      axios
        .post(api.addClientView, params)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: `编辑${params.vchannel ? '资讯台' : '中文台'}信息成功`,
              type: 'success'
            })
            this.clientViewFormShow = false
            this.dialogLoading = false;
            this.getDetail()
          } else {
            this.$message.error(res.data.msg)
             this.dialogLoading = false;
          }
        })
        .catch(error => {
           this.dialogLoading = false;
          this.$message.error('网络错误，稍后重试')
        })
    },
    //编辑数字电视
    editClientDigital() {
      if (this.clientDigital) {
        this.clientDigitalForm = _.pick(
          this.clientDigital,
          _.keys(this.clientDigitalForm)
        )
        this.clientDigitalForm.issignPhtv = !!this.clientDigitalForm.issignPhtv
        this.clientDigitalForm.dinclude = !!this.clientDigitalForm.dinclude
      } else {
        this.clientDigitalForm = {
          digitalTvUserNumber: '',
          dinclude: '',
          idDupcover: '',
          ddupsum: '',
          dvod: '',
          dsummary: '',
          dmemo: '',
          issignPhtv: false
        }
      }
      this.clientDigitalForm.cid = this.id
      this.clientDigitalShow = true
    },
    //提交数字电视
    submitClientDigitalView() {
       this.dialogLoading = true;
      let params = _.cloneDeep(this.clientDigitalForm)
      params.issignPhtv = Number(params.issignPhtv)
      params.dinclude = Number(params.dinclude)
      if (params.did) {
        axios
          .post(api.updateClientDigital, params)
          .then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '修改数字电视信息成功',
                type: 'success'
              })
              this.clientDigitalShow = false
               this.dialogLoading = false;
              this.getDetail()
            } else {
               this.dialogLoading = false;
              this.$message.error(res.data.msg)
            }
          })
          .catch(error => {
             this.dialogLoading = false;
            this.$message.error('网络错误，稍后重试')
          })
      } else {
        axios
          .post(api.addClientDigital, params)
          .then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '添加数字电视信息成功',
                type: 'success'
              })
              this.clientDigitalShow = false
               this.dialogLoading = false;
              this.getDetail()
            } else {
               this.dialogLoading = false;
              this.$message.error(res.data.msg)
            }
          })
          .catch(error => {
             this.dialogLoading = false;
            this.$message.error('网络错误，稍后重试')
          })
      }
    },
    //编辑联系人
    editContact(index) {
      if (index !== -1) {
        this.contactAdd=false
        this.contactForm = _.pick(this.contact[index], _.keys(this.contactForm))
        this.contactForm.cid = this.contact[index].cid
      } else {
        this.contactAdd=true
        this.contactForm = {
          cname: '',
          csex: '',
          cposition: '',
          cage: '',
          cphoen: '',
          ctel: '',
          czonecode: '',
          czipcode: '',
          cqm: '',
          caddress: '',
          cfax: '',
          cresume: '',
          ctype: 1
        }
      }
      this.contactFormShow = true
    },
    //提交联系人
    submitContact() {
      this.dialogLoading = true
      let params = _.cloneDeep(this.contactForm)
      params.mid = this.id
      if (!this.contactAdd) {
        //修改联系人
        axios
          .post(api.updateContacts, params)
          .then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '修改联系人信息成功',
                type: 'success'
              })
              this.contactFormShow = false
              this.dialogLoading = false;
              this.getDetail()
            } else {
              this.dialogLoading = false;
              this.$message.error(res.data.msg)
            }
          })
          .catch(error => {
            this.dialogLoading = false;
            this.$message.error('网络错误，稍后重试')
          })
      } else {
        //添加联系人
        axios
          .post(api.addContacts, params)
          .then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '添加联系人成功',
                type: 'success'
              })
              this.contactFormShow = false
              this.getDetail()
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(error => {
            this.$message.error('网络错误，稍后重试')
          })
      }
    },
    //关闭中文台或资讯台
    closeClientView(channel) {
      axios
        .post(api.closeClientView + `?Clientid=${this.id}&Channel=${channel}`)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: '关闭成功',
              type: 'success'
            })
            this.getDetail()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    },
    //开启中文台/资讯台
    openClientView(channel) {
      axios
        .post(api.openClientView + `?Clientid=${this.id}&Channel=${channel}`)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: '开启成功',
              type: 'success'
            })
            this.getDetail()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    },
    //删除数字信息
    delDigital(id) {
      this.$confirm('删除后不可恢复，确认删除？', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          axios
            .get(api.deleteClientDigital + `?id=${id}`)
            .then(res => {
              if (res.data.code === 0) {
                this.$message({
                  message: '删除数字信息成功',
                  type: 'success'
                })
                this.getDetail()
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch(error => {
              this.$message.error('网络错误，稍后重试')
            })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss">
.chinese_detail {
  .chinese_detail-wrap {
    padding: 77px 30px 0px 30px;
    .chinese_detail-contain {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #e6e3e3;
      .chinese_detail-row_wrap {
        margin-bottom: 19px;
      }
      .chinese_detail-add {
        cursor: pointer;
      }
      .el-row {
        padding: 13px 20px;
        &:nth-child(odd) {
          background: #f1f5f9;
        }
        &:nth-child(even) {
          background: #ffffff;
        }
      }
      .chinese_detail-contact {
        tr {
          th {
            height: 34px;
            background: #6e6e6e;
            color: #fff;
          }
          td {
            text-align: center;
            height: 37px;
          }
        }
      }
      .chinese_detail-history {
        border: 1px dashed rgba(220, 223, 230, 1);
        padding: 14px 19px 0px 19px;
        margin-bottom: 29px;
        .chinese_detail-history_title {
          margin-bottom: 12px;
          cursor: pointer;
        }
        th {
          height: 31px;
          background: #f0f0f0;
          &:nth-child(1) {
            padding-left: 15px;
            text-align: left;
          }
        }
        tr {
          td {
            border-bottom: 1px solid rgba(220, 223, 230, 1);
            padding: 15px;
            text-align: center;
            background: #fff;
            &:nth-child(1) {
              text-align: left;
            }
          }
          &:nth-last-child(1) {
            td {
              border: none;
            }
          }
        }
      }
    }
  }
  .chinese_detail-dialog {
    .el-dialog {
      min-width: 745px;
    }
    .el-dialog__header {
      color: #4a4a4a;
      font-weight: 600;
      font-size: 18px;
    }
    .el-dialog__body {
      padding-top: 6px;
      padding-bottom: 0px;
    }
    .el-dialog__footer {
      padding-top: 0px;
      text-align: left;
      .el-button {
        width: 88px;
      }
    }

    .chinese_detail-form {
      .el-form-item {
        .el-select {
          width: 100%;
        }
        .el-form-item__label {
          font-size: 16px;
          color: #4a4a4a;
          line-height: 22px;
          margin-top: 3px;
          padding-bottom: 11px;
        }
        .el-radio-group {
          height: 40px;
          align-items: center;
          border-radius: 4px;
          border: 1px solid rgba(220, 223, 230, 1);
          padding: 0px 20px 0 14px;
          display: flex;
          justify-content: space-between;
        }
        .el-checkbox-group {
          border-radius: 4px;
          border: 1px solid rgba(220, 223, 230, 1);
          padding: 0px 20px 0 14px;
          display: flex;
          justify-content: space-between;
        }
      }
      .chinese_detail-checkbox {
        height: 38px;
        line-height: 38px;
        padding: 0px 13px;
        border-radius: 4px;
        border: 1px solid rgba(220, 223, 230, 1);
        margin-top: 36px;
      }
    }
  }
}
</style>
